import { number, object, iso8601 } from "decoders";

const favouriteOfferId = object({
    offerId: number
});
  
export const vfFavourite = object({
    favouriteOfferId: favouriteOfferId,
    createdOn: iso8601
});